<app-loading *ngIf="loading"></app-loading>
<div *ngIf="!loading">
<form [formGroup]="formulario" (ngSubmit)="crear()" novalidate id="fCondiciones" name="fCondiciones" *ngIf="!verDetalle">
  <div class="grid form-group">
    <div class="col-12 md:col-4 lg:col-4" [ngClass]="{
              'col-12 md:col-3 lg:col-3': variable.codigoVariableSarlaft === tipOpcion.JURISD,
              'col-12 md:col-4 lg:col-4': variable.codigoVariableSarlaft !== tipOpcion.JURISD
            }" *ngIf="!verDetalle && variable &&
        (variable.codigoVariableSarlaft === tipOpcion.NACION ||
        variable.codigoVariableSarlaft === tipOpcion.PEP ||
        variable.codigoVariableSarlaft === tipOpcion.PRODUC ||
        variable.codigoVariableSarlaft === tipOpcion.OCUPAC ||
        variable.codigoVariableSarlaft === tipOpcion.TIPOCU ||
        variable.codigoVariableSarlaft === tipOpcion.VCANAL ||
        variable.codigoVariableSarlaft === tipOpcion.JURISD ||
         variable.codigoVariableSarlaft === tipOpcion.ACTECO)">
      <div class="div-form" >
        <label>* {{nombreGenerico}}</label>
        <p-dropdown disableTab  id="idLista" name="lista" [options]="lisgenerica"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                     formControlName="idLista"
                    [disabled]="disabledLista"
                    (onChange)="asignarLista()"
                    emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    optionValue="value"
                    optionLabel="label"
                    filter="filter"
        ></p-dropdown>
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="submitted && f.idLista.invalid"
        >
          {{ nombreGenerico }}
          {{ "LBL_REQUERIDO" | translate }}
        </div>
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2" *ngIf=" !verDetalle && variable &&
          (variable.codigoVariableSarlaft === tipOpcion.JURISD)">
      <div class="div-form">
        <label>* {{"SARLAFT.LBL_JURISDICCION" | translate}}</label>
        <p-dropdown disableTab
          id="idDivisionPolitica"
          name="departamento"
          formControlName="idDivisionPolitica"
          [options]="listaDepartamentos"
          placeholder="{{ 'LBL_SELECCIONE' | translate }}"
          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
          optionValue="value"
          optionLabel="label"
          filter="true"
          [disabled]="!segundoInputHabilitado || disabledLista"
        ></p-dropdown>
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="submitted && f.idDivisionPolitica.invalid"
        >
          {{ "SARLAFT.LBL_JURISDICCION" | translate }}
          {{ "LBL_REQUERIDO" | translate }}
        </div>
      </div>
      <div class="div-form" *ngIf="verDetalle && variable &&
       (variable.codigoVariableSarlaft === 'NACION' ||
       variable.codigoVariableSarlaft === tipOpcion.JURISD)">
        <label>{{ "SARLAFT.LBL_JURISDICCION" | translate }}</label>
        <label class="falso-combo-texto"></label>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2" *ngIf=" variable &&
          (variable.codigoVariableSarlaft === tipOpcion.INFIIN ||
           variable.codigoVariableSarlaft === tipOpcion.INFIEG ||
           variable.codigoVariableSarlaft === tipOpcion.INFIAC ||
            variable.codigoVariableSarlaft === tipOpcion.INFIPT ||
             variable.codigoVariableSarlaft === tipOpcion.INFIPA)">
      <div class="div-form">
        <label>* {{"SARLAFT.LBL_VARIABLE" | translate}}</label>
        <label class="falso-combo-texto">{{variable.variableSarlaft}}</label>
      </div>
    </div>
    <div class="col-12 md:col-1 lg:col-1" *ngIf=" variable &&
          (variable.codigoVariableSarlaft === tipOpcion.INFIIN ||
           variable.codigoVariableSarlaft === tipOpcion.INFIEG ||
           variable.codigoVariableSarlaft === tipOpcion.INFIAC ||
            variable.codigoVariableSarlaft === tipOpcion.INFIPT ||
            variable.codigoVariableSarlaft === tipOpcion.INFIPA )">
      <div class="div-form">
        <label>* {{"SARLAFT.LBL_CODIGO" | translate}}</label>
        <input type="text" pInputText id="codigo"
               name="nomCodigo"
               autocomplete="off"
               formControlName="codigo"
               maxlength="6"
               (blur)="validarCodigo()"
               codigos-reactive
        >
        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
          {{ 'SARLAFT.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
        </div>
        <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
          {{ 'SARLAFT.MSG_CODIGOEXISTE' | translate}}
        </div>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2" *ngIf=" variable &&
          (variable.codigoVariableSarlaft === tipOpcion.INFIIN ||
           variable.codigoVariableSarlaft === tipOpcion.INFIEG ||
           variable.codigoVariableSarlaft === tipOpcion.INFIAC ||
            variable.codigoVariableSarlaft === tipOpcion.INFIPT ||
             variable.codigoVariableSarlaft === tipOpcion.INFIPA)">
      <div class="div-form">
        <label>* {{"SARLAFT.LBL_RANGOINICIAL" | translate}}</label>
        <input
          type="text"
          pInputText
          id="rangoInicial"
          name="rangoInicial"
          autocomplete="new-password"
          formControlName="rangoInicial"
          maxlength="18"
          moneda-reactive
          [minimo]="0" (blur)="validarRangos($event, true)"
        >
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="submitted && f.rangoInicial.invalid"
        >
          {{ "SARLAFT.LBL_RANGOINICIAL" | translate }}
          {{ "LBL_REQUERIDO" | translate }}
        </div>
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="!rangoIncialValido"
        >
          {{ "SARLAFT.LBL_RANGONOVALIDO" | translate }}
        </div>
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2" *ngIf="variable &&
          (variable.codigoVariableSarlaft === tipOpcion.INFIIN ||
           variable.codigoVariableSarlaft === tipOpcion.INFIEG ||
           variable.codigoVariableSarlaft === tipOpcion.INFIAC ||
            variable.codigoVariableSarlaft === tipOpcion.INFIPT ||
            variable.codigoVariableSarlaft === tipOpcion.INFIPA)">
      <div class="div-form">
        <label>* {{"SARLAFT.LBL_RANGOFINAL" | translate}}</label>
        <input
          type="text"
          pInputText
          id="rangoFinal"
          name="rangoFinal"
          autocomplete="new-password"
          formControlName="rangoFinal"
          maxlength="18"
          moneda-reactive
          [minimo]="0"
          (blur)="validarRangos($event, false)"
        >
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="submitted && f.rangoFinal.invalid"
        >
          {{ "SARLAFT.LBL_RANGOFINAL" | translate }}
          {{ "LBL_REQUERIDO" | translate }}
        </div>
      </div>
    </div>

    <div [ngClass]="{'col-12 md:col-2 lg:col-2': !verDetalle && variable &&
        (variable.codigoVariableSarlaft === tipOpcion.PEP)}"
         *ngIf="!verDetalle &&
      (variable.codigoVariableSarlaft === tipOpcion.PEP)">
      <div class="div-form">
        <label>* {{ "SARLAFT.LBL_VALOR" | translate }}</label>
        <p-dropdown disableTab
          id="valor"
          name="valor"
          formControlName="valor"
          [options]="listaboolean"
          placeholder="{{ 'LBL_SELECCIONE' | translate }}"
          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
          optionValue="value"
          optionLabel="label"
        ></p-dropdown>
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="submitted && f.valor.invalid"
        >
          {{ "SARLAFT.LBL_VALOR" | translate }}
          {{ "LBL_REQUERIDO" | translate }}
        </div>
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2" *ngIf=" !verDetalle && variable &&
        (variable.codigoVariableSarlaft === tipOpcion.NACION ||
        variable.codigoVariableSarlaft === tipOpcion.VCANAL ||
        variable.codigoVariableSarlaft === tipOpcion.TIPOCU ||
        variable.codigoVariableSarlaft === tipOpcion.JURISD ||
        variable.codigoVariableSarlaft === tipOpcion.PEP ||
        variable.codigoVariableSarlaft === tipOpcion.PRODUC ||
        variable.codigoVariableSarlaft === tipOpcion.OCUPAC ||
        variable.codigoVariableSarlaft === tipOpcion.INFIIN ||
        variable.codigoVariableSarlaft === tipOpcion.INFIEG ||
        variable.codigoVariableSarlaft === tipOpcion.INFIAC ||
        variable.codigoVariableSarlaft === tipOpcion.INFIPT ||
         variable.codigoVariableSarlaft === tipOpcion.INFIPA ||
        variable.codigoVariableSarlaft === tipOpcion.ACTECO)">
      <div class="div-form">
        <label>* {{ "SARLAFT.LBL_PUNTAJE" | translate }}</label>
        <input
          type="text"
          pInputText
          id="puntaje"
          name="puntaje"
          autocomplete="off"
          formControlName="puntaje"
          appTexto
          maxlength="5"
          numero-entero-reactive
          [sinComa]="true"
          [sinEspacio]="true"
          [sinCaracteres]="true"
          [sinPunto]="true"
          [sinLetras]="true"
        >
        <div
          class="p-message p-messages-error p-corner-all"
          *ngIf="submitted && f.puntaje.invalid"
        >
          {{ "SARLAFT.LBL_PUNTAJE" | translate }}
          {{ "LBL_REQUERIDO" | translate }}
        </div>
      </div>
      <div class="div-form" *ngIf="verDetalle && variable &&
       (variable.codigoVariableSarlaft === 'NACION' ||
        variable.codigoVariableSarlaft === tipOpcion.JURISD)">
        <label>{{ "SARLAFT.LBL_PUNTAJE" | translate }}</label>
        <label class="falso-combo-texto"></label>
      </div>
    </div>
    <div class="col-12 md:col-1 lg:col-1">
      <div class="div-form" >
        <label>{{ "SARLAFT.LBL_PESO" | translate }}:</label>
        <label class="falso-combo-texto">{{ variable.peso }}</label>
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2">
      <div class="div-form" >
        <label>{{ "SARLAFT.LBL_PONDERACION" | translate }}:</label>
        <label class="falso-combo-texto">{{ (f.puntaje.value * variable.peso)/100 }}</label>
      </div>
    </div>
    <div class="contenedor-cargueArchivo col-12 lg:col-2 md:col-2" *ngIf="!verDetalle && variable &&
       (variable.codigoVariableSarlaft === 'NACION' ||
       variable.codigoVariableSarlaft === tipOpcion.JURISD ||
       variable.codigoVariableSarlaft === tipOpcion.PRODUC ||
       variable.codigoVariableSarlaft === tipOpcion.OCUPAC ||
       variable.codigoVariableSarlaft === tipOpcion.ACTECO)">
      <div class="div-form">
        <div class="btn-group" role="group"
             style="display: block;">
          <label class="btn btn-default" style="max-width: 87%; overflow: hidden;" *ngIf="nombreCargueArchivo || nombreArchivo">
            <i class="fa fa-file-o" aria-hidden="true"></i>
            {{ nombreArchivo ? nombreArchivo : nombreCargueArchivo }}
          </label>
          <a class="btn btn-danger" *ngIf="nombreArchivo"
             (click)="eliminarAdjunto()" style="padding: 3px; border-radius: 5px;">
            <i class="fa fa-times" aria-hidden="true"></i>
          </a>
        </div>
        <p-fileUpload name="file" [auto]="false" class="upload-avatar"
                      chooseLabel="{{'SARLAFT.LBL_CARGARARCHIVO' | translate}}" #adjunto
                      (onUpload)="onUpload($event)" url="{{rutaAdjunto}}" fSize accept="{{ftype}}"
                      [omitirType]="true"
                      invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                      invalidFileTypeMessageDetail="{{'PRODUCTO.LBL_FILETIPOES' | translate}}"
                      (onValidSelect)="onSelect($event, $event.files)"
                      (onBeforeUpload)="onBeforeSend($event)"
                      mode="basic">
        </p-fileUpload>
        <div *ngIf="false">
          {{ 'LBL_TAMANOMAXIMO' | translate}}: {{fsize / 1000000}} MB <br>
          {{ 'LBL_TIPOARCHIVO' | translate}}: {{'PRODUCTO.FTYPE' | translate }}
        </div>
      </div>

    </div>
  </div>
  <div class="grid">
    <div class="form-group col-12">
      <div *ngIf="!cargaCondiciones" style="display: flex;justify-content: center">
        <div class="col-12 md:col-6 lg:col-6" style="display: flex;justify-content: center">
          <button *ngIf="!estadoEditar" type="submit" pButton icon="fa fa-plus"
                  label="{{ 'BTN_AGREGAR' | translate}}"></button>
          <button *ngIf="estadoEditar" type="submit" pButton icon="fa fa-plus"
                  label="{{ 'BTN_GUARDAR' | translate}}"></button>
        </div>
      </div>
      <div *ngIf="cargaCondiciones" class="col-12 flex justify-content-center align-items-center">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
        <span>{{ "LBL_GUARDANDO" | translate }}</span>
      </div>
    </div>
  </div>
</form>
<div class="grid" style="display: flex;justify-content: flex-end">
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
            (input)="dt.filterGlobal($event.target.value, 'contains')"
            [(ngModel)]="busqueda" (change)="setBusqueda()">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="cargaCondiciones" #dt
              [value]="condicion" selectionMode="single" dataKey="idCanal"
              [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr [pSelectableRow]="row">
          <ng-container *ngFor="let col of columns; let lastCol = last">
            <td class="text-center p-va-middle" *ngIf="!lastCol">
              {{ (row[col.field] === row.rangoInicial || row[col.field] === row.rangoFinal) ? (row[col.field] | number) :  row[col.field] }}
            </td>
            <td class="text-center p-va-middle" *ngIf="verDetalle && lastCol">
              {{ row[col.field] }}
            </td>
          </ng-container>
          <td class="text-center" *ngIf="!verDetalle">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton
                      (click)="editarCondicion(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                      title="{{ 'BTN_ELIMINAR' | translate }}" pButton
                      (click)="inhabilitarCondicion(row)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
</div>
<p-dialog [closable]="false"
          [closeOnEscape]="false"
          [resizable]="false"
          [draggable]="false"
          [(visible)]="modalAbierto"
          [modal]="true"
          [contentStyle]="modal"
          header=" {{ 'SARLAFT.LBL_CARGAREGISTROS' | translate }}">

  <div *ngIf="estado==='car'">
    <div style="color: grey; text-align: center">
      {{ 'SARLAFT.LBL_CARGADEARCHIVOS' | translate }} {{fechaCargueArchivo}}
    </div>
    <div style="margin-top: 15px; text-align: center">
      <p style="margin: 0">{{ 'SARLAFT.LBL_ESPERAUNMOMENTOUNO' | translate }}</p>
      <p style="margin: 0">{{ 'SARLAFT.LBL_ESPERAUNMOMENTODOS' | translate }}</p>
    </div>
    <div style="text-align: center; margin-top: 8px">
      <img src="assets/images/cargando-sarlaft.svg" alt="" height="100">
    </div>
    <div class="grid botones-sarlaft">
      <div class="form-group col-12">
        <button label="{{ 'BTN_CANCELAR' | translate }}" type="button"
                pButton style="background-color: #cccccc; color: #4d4d4d"
                (click)="cerrarModal()"></button>
      </div>
    </div>
  </div>
  <div *ngIf="estado==='mal'">
    <div style="text-align: center">
      <i class="fa fa-times-circle fa-2x icon-politica icon-politica-denegacion" style="font-size: 50px"></i>
    </div>
    <div style="margin-top: 10px; text-align: center">
      <p style="margin: 0" *ngIf="mensajes.length===0 || mensajes.length===1">(1) {{ 'SARLAFT.LBL_ERRORENCONTRADO' | translate }}</p>
      <p style="margin: 0" *ngIf="mensajes.length>1">({{mensajes.length}}) {{ 'SARLAFT.LBL_ERRORENCONTRADOPLURAL' | translate }}</p>
    </div>
    <div style="text-align: center; margin-top: 20px; padding: 5px; max-height: 210px; overflow-y: scroll" *ngIf="mensajes.length>0">
      <div *ngFor="let mensaje of mensajes | keyvalue; index as i ">
        ({{i+1}}) {{mensaje.value}}
      </div>
    </div>
    <div style="text-align: center; margin-top: 20px;">
      <p style="background-color: #fceaea; color: #e13030; border-radius: 5px; padding: 7px">{{ 'SARLAFT.LBL_MENSAJEFALLO' | translate }}</p>
    </div>
    <div class="grid botones-sarlaft">
      <div class="form-group col-12">
        <button label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton style="background-color: #cccccc; color: #4d4d4d"
                (click)="cerrarModal()"></button>
      </div>
    </div>
  </div>
  <div *ngIf="estado==='bien'">
    <div style="text-align: center">
      <i class="fa fa-check-circle fa-2x icon-politica icon-politica icon-politica-cumple" style="font-size: 50px"></i>
    </div>
    <div style="margin-top: 15px; text-align: center" [innerHTML]="mensajes[0]"></div>
    <div class="grid botones-sarlaft">
      <div class="form-group col-12">
        <button label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton style="background-color: #cccccc; color: #4d4d4d; margin-right: 8px"
                (click)="cerrarModalExito(false)"></button>
        <button label="{{ 'SARLAFT.BTN_IMPORTAR' | translate }}" type="button"
                pButton style="background-color: #009638; color: white; margin-left: 8px"
                (click)="cerrarModalExito(true)"></button>
      </div>
    </div>
  </div>
</p-dialog>

<p-confirmDialog #cd key="confirmacion-adjunto">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #cg appendTo="body" key="confirmar-guardado">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cg.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cg.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #ci appendTo="body" key="confirmar-condicionInformacionFinanciera">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_CANCELAR' | translate }}" (click)="ci.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_ACEPTAR' | translate }}" (click)="ci.accept()"></button>
  </ng-template>
</p-confirmDialog>
